import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "games-page" }
const _hoisted_2 = { class: "games-header" }
const _hoisted_3 = { class: "games-meta" }
const _hoisted_4 = { class: "page-eyebrow" }
const _hoisted_5 = { class: "games-count" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "games-grid" }
const _hoisted_8 = { class: "disclaimer glass-card" }
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DemoGame = _resolveComponent("DemoGame")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.jsonData.eyebrowCatalogue), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.slides.length) + " " + _toDisplayString(_ctx.jsonData.gamesCountLabel), 1)
      ]),
      _createElementVNode("h1", {
        innerHTML: _ctx.jsonData.ourGame
      }, null, 8, _hoisted_6),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-divider" }, null, -1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slides, (slide, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["game-wrap", { 'game-wrap--split': _ctx.showGameDescription }]),
          key: index,
          style: _normalizeStyle({'--stagger': index})
        }, [
          _createVNode(_component_DemoGame, {
            name: slide.name,
            image: slide.image,
            description: slide.description,
            src: slide.src,
            url: slide.url,
            isBtnAvalebl: true,
            game: slide.game,
            inDev: slide.inDev
          }, null, 8, ["name", "image", "description", "src", "url", "game", "inDev"])
        ], 6))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("p", {
        class: "lit_h1",
        innerHTML: _ctx.jsonData.demoGameHaderIntroText
      }, null, 8, _hoisted_9),
      _createElementVNode("p", {
        class: "lit_size",
        innerHTML: _ctx.jsonData.demoGameIntroText
      }, null, 8, _hoisted_10)
    ])
  ]))
}